import { Injectable } from '@angular/core';

import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class DateParserFormatterService extends NgbDateParserFormatter {
	parse(value: string): NgbDateStruct | null {
		if (value) {
			const date = value.split('/');
			return {
				day: parseInt(date[0], 10),
				month: parseInt(date[1], 10),
				year: parseInt(date[2], 10),
			};
		}
		return null;
	}

	format(date: NgbDateStruct | null): string {
		return date ? `${date.day}/${date.month}/${date.year}` : '';
	}
}
